import {Dispatch, SetStateAction} from "react";
import Form from 'react-bootstrap/Form';
import {useTranslation} from "react-i18next";

interface RowsPerPageProps {
    rowsPerPage : number
    setRowsPerPage?: Dispatch<SetStateAction<number>>
    setCurrentPage?: Dispatch<SetStateAction<number>>
}

export const RowsPerPage = ({rowsPerPage, setRowsPerPage, setCurrentPage} : RowsPerPageProps) =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslation();

    const onChangeRowsPerPage = (newRowsPerPage : number) =>
    {
        if (setRowsPerPage !== undefined) {
            setRowsPerPage(newRowsPerPage);
        }

        // reset the current page because the old page might not exist
        if (setCurrentPage !== undefined) {
            setCurrentPage(1);
        }
    }


    return (
        <>
            <Form.Select className="d-none d-lg-block" value={rowsPerPage}
                         onChange={(e) => onChangeRowsPerPage(Number(e.target.value))}>
                <option value="5">5 {t("pager.rows-per-page")}</option>
                <option value="10">10 {t("pager.rows-per-page")}</option>
                <option value="20">20 {t("pager.rows-per-page")}</option>
                <option value="40">40 {t("pager.rows-per-page")}</option>
                <option value="80">80 {t("pager.rows-per-page")}</option>
            </Form.Select>

            <Form.Select className="d-lg-none" value={rowsPerPage}
                         onChange={(e) => onChangeRowsPerPage(Number(e.target.value))}>
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="40">40</option>
                <option value="80">80</option>
            </Form.Select>
        </>
    )
}
